module.exports = __webpack_public_path__ + "img/906.db9da514.jpg";